import customer_logo_0 from '/public/about/customers/0.png';
import customer_logo_1 from '/public/about/customers/1.png';
import customer_logo_2 from '/public/about/customers/2.png';
import customer_logo_3 from '/public/about/customers/3.png';
import customer_logo_4 from '/public/about/customers/4.png';
import customer_logo_5 from '/public/about/customers/5.png';
import customer_logo_6 from '/public/about/customers/6.png';
import customer_logo_7 from '/public/about/customers/7.png';
import customer_logo_8 from '/public/about/customers/8.png';
import customer_logo_9 from '/public/about/customers/9.png';
import customer_logo_10 from '/public/about/customers/10.png';
import customer_logo_11 from '/public/about/customers/11.png';
import customer_logo_12 from '/public/about/customers/12.png';
import customer_logo_13 from '/public/about/customers/13.png';
import customer_logo_14 from '/public/about/customers/14.png';
import customer_logo_15 from '/public/about/customers/15.png';
import customer_logo_16 from '/public/about/customers/16.png';
import customer_logo_17 from '/public/about/customers/17.png';
import customer_logo_18 from '/public/about/customers/18.png';
import customer_logo_19 from '/public/about/customers/19.png';


const CUSTOMER_LOGOS = [customer_logo_0,customer_logo_1,customer_logo_2,customer_logo_3,customer_logo_4,customer_logo_5,customer_logo_6,customer_logo_7,customer_logo_8,customer_logo_9,customer_logo_10,customer_logo_11,customer_logo_12,customer_logo_13,customer_logo_14,customer_logo_15,customer_logo_16,customer_logo_17,customer_logo_18,customer_logo_19];
const CUSTOMERS = {"title":"服务客户2000+","logos":["customers/0.png","customers/1.png","customers/2.png","customers/3.png","customers/4.png","customers/5.png","customers/6.png","customers/7.png","customers/8.png","customers/9.png","customers/10.png","customers/11.png","customers/12.png","customers/13.png","customers/14.png","customers/15.png","customers/16.png","customers/17.png","customers/18.png","customers/19.png"]};
export {CUSTOMER_LOGOS, CUSTOMERS};